import React from "react";
import { useTranslation } from "react-i18next";
import "./Footer.css";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="footer">
      <p>{t('footer_rights_reserved')}</p>
    </footer>
  );
};

export default Footer;
